// Launchpad — full-page Lifted AI Assistant.
// Mounted at /launchpad/assistant.
import React from "react";
import AssistantPanel from "@/components/assistant/AssistantPanel";

export default function LaunchpadAssistant() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10 space-y-6" data-testid="launchpad-assistant-page">
      <header>
        <div className="eyebrow text-lifted-dim">Lifted Launchpad</div>
        <h1 className="font-anton text-4xl sm:text-5xl uppercase text-white">Meet X — your Lifted AI guide</h1>
        <p className="text-lifted-dim text-sm mt-2 max-w-2xl">
          X is the operating assistant for the Lifted ecosystem. Ask anything
          about products, the affiliate program, Lifted Supplies delivery, or
          how to find your fit inside Lifted.
        </p>
      </header>

      <AssistantPanel
        surface="launchpad"
        title="X — Lifted AI"
        subtitle="Find where you fit · daily lead help · content ideas"
        className="bg-black/50"
        testid="launchpad-assistant"
      />

      <section className="grid grid-cols-1 sm:grid-cols-3 gap-3 pt-2">
        <Prompt q="How does the Lifted affiliate program work?" />
        <Prompt q="Write me an Instagram DM to a creator with 8K followers about partnering with Lifted." />
        <Prompt q="Give me 3 content ideas I can post today as a new Lift-Off affiliate." />
      </section>
    </div>
  );
}

function Prompt({ q }) {
  return (
    <div
      className="glass-panel p-4 text-xs text-lifted-dim leading-relaxed"
      data-testid="launchpad-prompt-card"
    >
      <div className="font-bebas uppercase text-[10px] tracking-[0.18em] text-lifted-green mb-1">Try asking</div>
      “{q}”
    </div>
  );
}
